import { render, staticRenderFns } from "./PostPortfolio.vue?vue&type=template&id=133fb13a&scoped=true"
import script from "./PostPortfolio.vue?vue&type=script&lang=js"
export * from "./PostPortfolio.vue?vue&type=script&lang=js"
import style0 from "./PostPortfolio.vue?vue&type=style&index=0&id=133fb13a&prod&scoped=true&lang=css"
import style1 from "./PostPortfolio.vue?vue&type=style&index=1&id=133fb13a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133fb13a",
  null
  
)

export default component.exports